export const blackTextColors = [
  "White",
  "Ivory",
  "Cream",
  "Gold",
  "Lemon",
  "Limeneon",
  "Greenneon",
  "Arcticblue",
  "Seta",
  "OffWhite",
  "WhiteFlowers",
  "ButterPopcorn",
  "IceCap",
  "Aqua",
  "Pearl",
  "TeaRosa",
  "Pink",
  "Khaki",
  "Sage",
  "SilkWhite",
  "BlueFloralPrint",
  "SeaShellPink",
  "IceBlue",
  "LightBlue",
  "Salad",
  "DarkGreyLavender",
  "WhiteBeige",
  "BordeauxGold",
  "Turquoise",
  "Plaisir",
  "NeonLime",
  "NeonYellow",
  "TheatricalPink",
  "Angels",
  "Baroque",
  "Tiffany",
  "Lilac",
  "Peach",
  "Yellow",
  "YellowClearCrystal",
  "PowderBlue",
  "BalletPink",
  "Lime",
  "BlackPowderBlue",
  "EtabetaCristallo",
  "PlaisirCristallo",
  "LipsCristallo",
  "PonyCristallo",
  "Etabeta",
  "PowderFlowers",
  "TiffanyFlowers",
  "Camellia",
  "BlossomingGarden",
];
